import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';
export default Object.freeze({
	GENERAL: `${RouteNames.QUEUES}-general`,
	PARAMETERS: `${RouteNames.QUEUES}-parameters`,
	PROCESSING: `${RouteNames.QUEUES}-processing`,
	AGENTS: `${RouteNames.QUEUES}-agents`,
	SKILLS: `${RouteNames.QUEUES}-skills`,
	RESOURCES: `${RouteNames.QUEUES}-resources`,
	BUCKETS: `${RouteNames.QUEUES}-buckets`,
	HOOKS: `${RouteNames.QUEUES}-hooks`,
	VARIABLES: `${RouteNames.QUEUES}-variables`,
	PERMISSIONS: `${RouteNames.QUEUES}-permissions`,
	LOGS: `${RouteNames.QUEUES}-logs`,
	AMD: `${RouteNames.QUEUES}-amd`,
	MEMBERS_GENERAL: `${RouteNames.MEMBERS}-general`,
	MEMBERS_VARIABLES: `${RouteNames.MEMBERS}-variables`,
});
